import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterStrip = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", msg: "" });
    try {
      const { data } = await axios.post(`${API}/subscribe`, { email });
      const label = {
        subscribed: "You're in — watch your inbox for launches and offers.",
        already_subscribed: "You're already on the list — thanks!",
        resubscribed: "Welcome back — we've reactivated your updates.",
      }[data.status] || "Subscribed.";
      setStatus({ state: "success", msg: label });
      setEmail("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setStatus({ state: "error", msg: typeof d === "string" ? d : "Could not subscribe. Please try again." });
    }
  };

  return (
    <section data-testid="newsletter-strip" className="relative py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl p-8 md:p-12"
          style={{
            background:
              "linear-gradient(120deg, #6B21D9 0%, #A855F7 55%, #22D3EE 100%)",
          }}
        >
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/15 blur-3xl" />
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-white/80 font-semibold mb-3">
                Stay in the loop
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight">
                Subscribe to our newsletter.
              </h3>
              <p className="mt-3 text-white/85 max-w-md">
                New regions, features and offers — delivered to your inbox.
              </p>
            </div>
            <form data-testid="newsletter-form" onSubmit={submit} className="flex flex-col gap-3">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  data-testid="newsletter-email"
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="flex-1 bg-white text-[#05030A] rounded-full px-5 py-3 placeholder:text-black/40 focus:outline-none focus:ring-2 focus:ring-white"
                />
                <button
                  type="submit"
                  data-testid="newsletter-submit"
                  disabled={status.state === "loading"}
                  className="rounded-full bg-[#05030A] text-white px-6 py-3 text-sm font-semibold hover:bg-[#0F0A19] transition-colors disabled:opacity-60"
                >
                  {status.state === "loading" ? "…" : "Subscribe"}
                </button>
              </div>
              {status.state === "success" && (
                <div data-testid="newsletter-success" className="text-white text-sm">
                  {status.msg}
                </div>
              )}
              {status.state === "error" && (
                <div data-testid="newsletter-error" className="text-white text-sm">
                  {status.msg}
                </div>
              )}
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NewsletterStrip;
